/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import { Form, Input, Checkbox, Button } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { MobileOutlined, SafetyOutlined } from '@ant-design/icons';
import CaptchaSlider from '../../../components/slider';
import CountdownButton from '../../../components/count-down';
import { APP_URL } from '../../../utils/config';

const FormItem = Form.Item;

type Props = {
  wrappedComponentRef: (ref: any) => any;
  onSubmit: (...args: any[]) => any;
  sendCode: (...args: any[]) => any;
  submitting?: boolean;
};

class MessageForm extends React.PureComponent<Props> {
  captchaRef: any;
  codeRef: any;
  sendTime: any;

  constructor(props: Props) {
    super(props);
    this.sendTime = undefined;
  }
  formRef = React.createRef<FormInstance>();
  handleSendCode = () => {
    const { current: form } = this.formRef;
    if (form) {
      // 再次点击“发送验证码”，先清空原输入信息
      form.setFieldsValue({
        password: '',
      });
      form
        .validateFields(['username', 'position'])
        .then((values) => {
          this.props
            .sendCode({ mobile: values.username, offset: values.position })
            .then((response: any) => {
              if (response.code === 0 && response.content !== false) {
                this.codeRef.startCountdown();
                this.sendTime = new Date().getTime();
                // pingback.send({
                //   eventId: 801,
                //   eventName: "短信验证码已发送成功"
                // });
              } else {
                this.captchaRef.reset();
                this.sendTime = undefined;
              }
            });
        })
        .catch(() => {
          this.captchaRef.reset();
        });
    }
  };

  setCodeRef = (ref: any) => {
    this.codeRef = ref;
  };

  setCaptchaRef = (ref: any) => {
    this.captchaRef = ref;
  };

  resetCaptcha = () => {
    this.captchaRef.reset();
  };

  handleCodeChange = (e: any) => {
    const value = e.target.value;

    if (/^\d{6}$/.test(value) && this.sendTime) {
      // pingback.send({
      //   eventId: 802,
      //   eventName: "短信送达时间",
      //   receivedTime: new Date().getTime() - this.sendTime
      // });
      this.sendTime = undefined;
    }
  };

  render() {
    const { onSubmit } = this.props;

    return (
      <Form
        ref={this.formRef}
        onFinish={() => {
          onSubmit(this.formRef, 'message');
        }}
      >
        <FormItem
          name="username"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入手机号码',
            },
            {
              pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
              message: '手机号码格式错误',
            },
          ]}
        >
          <Input prefix={<MobileOutlined />} placeholder="手机号码（仅支持中国大陆手机）" />
        </FormItem>
        <FormItem name="position" rules={[{ required: true, message: '请向右滑动完成拼图' }]}>
          <CaptchaSlider ref={this.setCaptchaRef} />
        </FormItem>
        <FormItem
          className="form-item-sms"
          name="password"
          validateTrigger="onBlur"
          rules={[
            { required: true, message: '请输入短信验证码' },
            {
              pattern: /^\d{6}$/,
              message: '短信验证码格式错误',
            },
          ]}
        >
          <Input
            prefix={<SafetyOutlined />}
            placeholder="短信验证码"
            onChange={this.handleCodeChange}
            suffix={<CountdownButton ref={this.setCodeRef} onClick={this.handleSendCode} />}
          />
        </FormItem>
        <FormItem name="rememberMe" valuePropName="checked" className="form-check">
          <Checkbox>记住我</Checkbox>
        </FormItem>
        <FormItem>
          <a
            className="login-form-forgot"
            href={`${APP_URL}/sign/#!/forgetPassword`}
            target="_blank"
          >
            忘记密码？
          </a>
          <Button
            className="form-submit-button"
            type="primary"
            htmlType="submit"
            loading={this.props.submitting}
          >
            登录
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default MessageForm;
